import React from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as counterActions from "../../../src/modules/counterparties/action";
import SimpleSnackbar from '../../components/SimpleSnackbar';
import { userDetail } from "../../config/userDetails";

const InviteButtonTabHeader = ({
  header,
  path,
  btnLabel,
  isDisabled,
  isVisible = true,
  searchField = null, ...props
}) => {
  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [name, setName] = React.useState("");
  const [emailError, setEmailError] = React.useState("");
  const [nameError, setNameError] = React.useState("");

  const handleClose = () => {
    setOpen(false);
    props.handleSubmit();
  }

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }

  const validateName = (name) => {
    return name.trim().length > 0;
  }

  const submit = () => {
    let isValid = true;

    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address.");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (!validateName(name)) {
      setNameError("Please enter a name.");
      isValid = false;
    } else {
      setNameError("");
    }

    if (isValid) {
      props.actions.sendInvite({
        "email": email,
        "name": name,
        "userType": "COUNTERPARTY"
      });
      handleClose();
    }
  }

  return (
    <div className="flex-display ticket-header">
      <h3 className="mainHeading">{header}</h3>
      {searchField}
      <SimpleSnackbar />
      <button style={{visibility:userDetail().roleName ==="FARM_EMPLOYEE" ? "hidden":'visible'}} className="element_button" onClick={() => { setOpen(true) }}>{btnLabel}</button>
      <Dialog open={open} onClose={() => handleClose()} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Invite new Counterparty</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            fullWidth
            error={!!nameError}
            helperText={nameError}
            onChange={(e) => { setName(e.target.value) }}
          />
          <TextField
            margin="dense"
            id="email"
            label="Email Address*"
            type="email"
            fullWidth
            error={!!emailError}
            helperText={emailError}
            onChange={(e) => { setEmail(e.target.value) }}
          />
        </DialogContent>
        <DialogActions>
          <button className="transparent" onClick={() => handleClose()}>
            Cancel
          </button>
          <button className="element_button" onClick={() => submit()} color="primary">
            Send Invite
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

function mapStateToProps(state, props) {
  return {
    CounterPartyTicketList: state.ticketReducer.CounterPartyTicketList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...counterActions,
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InviteButtonTabHeader);



// WEBPACK FOOTER //
// ./src/components/Common/InviteButtonTabHeader.js